const prepareJSON = (data: any) => {
    return data.map((obj: any) => {
        return {
            width: obj.width,
            height: obj.height,
            data: {
                id: obj.id,
                name: obj.name,
                // src: obj.src,
                origin: obj.origin,
            },
        };
    });
};
export default prepareJSON;
